import StartLayout from './start-layout'

export default StartLayout
